import script from "./PetugasPage.vue?vue&type=script&setup=true&lang=js"
export * from "./PetugasPage.vue?vue&type=script&setup=true&lang=js"

import "./PetugasPage.vue?vue&type=style&index=0&id=40651439&lang=css"

const __exports__ = script;

export default __exports__